function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "close_svg__a",
  width: "136.7%",
  height: "135.5%",
  x: "-18.3%",
  y: "-17.8%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feMorphology", {
  "in": "SourceAlpha",
  operator: "dilate",
  radius: 9,
  result: "shadowSpreadOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 12,
  "in": "shadowSpreadOuter1",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 14
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  "in": "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  "in": "SourceGraphic"
}))));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  filter: "url(#close_svg__a)",
  transform: "translate(-421 -24)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M439.77 28l1.23 1.23-6.77 6.77 6.77 6.77-1.23 1.23-6.77-6.77-6.77 6.77-1.23-1.23 6.769-6.77L425 29.23l1.23-1.23 6.77 6.769L439.77 28z"
}));

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E %3Cdefs%3E %3Cfilter id='pwk9upibqa' width='136.7%25' height='135.5%25' x='-18.3%25' y='-17.8%25' filterUnits='objectBoundingBox'%3E %3CfeMorphology in='SourceAlpha' operator='dilate' radius='9' result='shadowSpreadOuter1'/%3E %3CfeOffset dx='2' dy='12' in='shadowSpreadOuter1' result='shadowOffsetOuter1'/%3E %3CfeGaussianBlur in='shadowOffsetOuter1' result='shadowBlurOuter1' stdDeviation='14'/%3E %3CfeColorMatrix in='shadowBlurOuter1' result='shadowMatrixOuter1' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0'/%3E %3CfeMerge%3E %3CfeMergeNode in='shadowMatrixOuter1'/%3E %3CfeMergeNode in='SourceGraphic'/%3E %3C/feMerge%3E %3C/filter%3E %3C/defs%3E %3Cg fill-rule='evenodd' filter='url(%23pwk9upibqa)' transform='translate(-421 -24)'%3E %3Cpath d='M439.77 28l1.23 1.23-6.77 6.77 6.77 6.77-1.23 1.23-6.77-6.77-6.77 6.77-1.23-1.23 6.769-6.77L425 29.23l1.23-1.23 6.77 6.769L439.77 28z'/%3E %3C/g%3E %3C/svg%3E";
export { SvgClose as ReactComponent };